window.addEventListener('turbo:load', function () {
  if (
    location.href.split('/').slice(-1) == 'properties' ||
    location.href.split('/').slice(-1) == 'syncs'
  ) {
    const syncButtons = document.getElementsByClassName('fa-sync');

    for (let i = 0; i < syncButtons.length; i++) {
      syncButtons[i].addEventListener('click', function () {
        localStorage.setItem('data-redirected-after-sync-start', 'true');
      });
    }
  }

  const failureRate = document.querySelector('.failure-rate');
  const failedIntegrationsBreakdown = document.querySelector('.failed-integrations-breakdown');

  if (failureRate) {
    const failureRateNumber = parseFloat(failureRate.innerHTML);

    if (failureRateNumber < 2) {
      failureRate.classList.add('failure-rate-green');
      failedIntegrationsBreakdown?.classList.add('failure-rate-green-bg');
    } else if (failureRateNumber >= 2 && failureRateNumber <= 5) {
      failureRate.classList.add('failure-rate-orange');
      failedIntegrationsBreakdown?.classList.add('failure-rate-orange-bg');
    } else {
      failureRate.classList.add('failure-rate-red');
      failedIntegrationsBreakdown?.classList.add('failure-rate-red-bg');
    }
  }
});
